import { IComponentOptions } from "angular";
import { GamingContractMasterAgreementEditComponentController } from "./controller";

export const vsComponentName = "gamingContractMasterAgreementEditComponent";

export const gamingContractMasterAgreementEditComponentOptions: IComponentOptions = {
  template: require("!html-loader!./index.html").default,
  controller: GamingContractMasterAgreementEditComponentController,
  controllerAs: "editController",
  bindings: {
    contract: "<",
    contractType: "<",
  },
};
